import { defineComponent } from "vue";
import * as yup from "yup";
import { mapState } from "vuex";

// Components
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import Typography from "@/components/general/Typography";
import Button from "@/components/general/Button";
import useInputs from "@/components/general/Inputs";
import Breadcrumb from "@/components/general/Breadcrumb";

// services
import processSevices from "@/services/legal/service.js";

const { Input, Select, Textarea, Date } = useInputs();
const string = yup
  .string()
  .nullable()
  .transform((curr, orig) => (orig === "" ? "" : curr));
const number = yup.number().nullable();
const object = yup
  .object()
  .shape({
    name: string,
    value: number | string,
  })
  .nullable();

let evaluateProcessFormSchema;

export default defineComponent({
  name: "Legal_process_evaluate",
  components: {
    MainBarMenuV2,
    HeadingUser,
    Typography,
    Button,
    Input,
    Select,
    Textarea,
    Date,
    Breadcrumb,
  },
  data() {
    return {
      breadcrumb: [
        { name: "Procesos", active: false, link: "/legal/process" },
        { name: "Evaluar proceso", active: true, link: "" },
      ],
      title: [
        "Análisis de Controles",
        "Actualizar Información",
        "Gestión del Riesgo",
      ],
      result: {
        color: '',
        name: '',
      },
      errors: {},
      file_number: "",
      fields: [],
      formData: {},
    };
  },
  methods: {
    goBack() {
      this.$router.push("/legal/process");
    },
    confirmCancel() {
      this.$bvModal.show("modal-confirm");
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    validate(field) {
      evaluateProcessFormSchema
        .validateAt(field, this.formData)
        .then(() => {
          this.computedErrors = field;
        })
        .catch((err) => {
          this.computedErrors = err;
        });
    },
    submitData() {
      evaluateProcessFormSchema
        .validate(this.formData)
        .then(() => {
          const formData = {
            process_id: this.$route.params.id,
            impact: this.fields.impact.map(v => {return this.formData[v.name]?.id}),
            probability: this.fields.probability.map(v => {return this.formData[v.name]?.id}),
          };
          processSevices
            .createEvaluation(formData)
            .then((response) => {
              if (!response.error) {
                this.result = response.data.result;
                this.$bvModal.show("modal-message");
              }else{
                Object.values(response.error.detail).forEach((v) =>
                  this.makeToast(v)
                );
              }
            });
        })
        .catch((err) => {
          this.computedErrors = err;
        });
    },
    initData() {
      processSevices.getOptionsEvaluation().then((response) => {
        this.fields = response.data;
        this.formData = Object.values(response.data.impact)
          .map((v) => {
            return v.name;
          })
          .concat(
            Object.values(response.data.probability).map((v) => {
              return v.name;
            })
          )
          .reduce((target, key) => {
            target[key] = null;
            return target;
          }, {});
        evaluateProcessFormSchema = yup.object().shape(
          Object.values(response.data.impact)
            .map((v) => {
              return v.name;
            })
            .concat(
              Object.values(response.data.probability).map((v) => {
                return v.name;
              })
            )
            .reduce((target, key) => {
              target[key] = object.required("Campo requerido");
              return target;
            }, {})
        );
        processSevices.getProcess(this.$route.params.id).then((response) => {
          this.file_number = response.data.file_number;
        });
      });
    },
    makeToast(msg) {
      this.toastCount++;
      this.$bvToast.toast(msg, {
        title: "Datos no guardados",
        autoHideDelay: 7000,
        appendToast: true,
        variant: "danger",
        solid: true,
        noCloseButton: true,
      });
    },
  },
  mounted() {
    this.initData();
    this.makeToast();
  },
  computed: {
    computedErrors: {
      get() {
        return this.errors;
      },
      set(newErr) {
        if (typeof newErr === "string") {
          delete this.errors[newErr];
        } else {
          if (newErr.path !== undefined) {
            const auxError = { [newErr.path]: newErr.message };
            this.errors = auxError;
          } else {
            console.error(newErr);
          }
        }
      },
    },
    ...mapState("modCore", ["user"]),
  },
});
